import React from "react";

function OtaIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 14.9046C2 15.4956 2.1164 16.0807 2.34254 16.6267C2.56869 17.1726 2.90016 17.6687 3.31802 18.0866C4.16193 18.9305 5.30653 19.4046 6.5 19.4046H18.5C19.386 19.4062 20.2396 19.0717 20.8886 18.4687C21.5377 17.8657 21.9339 17.0389 21.9973 16.1552C22.0608 15.2715 21.7867 14.3967 21.2304 13.7071C20.6742 13.0175 19.8771 12.5646 19 12.4396C19.0098 10.7384 18.3996 9.09181 17.2837 7.8077C16.1677 6.5236 14.6223 5.68985 12.9363 5.46232C11.2503 5.23479 9.5392 5.62904 8.12277 6.57138C6.70633 7.51372 5.68156 8.93965 5.24 10.5826C4.30512 10.8556 3.48398 11.4244 2.8998 12.2037C2.31562 12.983 1.99989 13.9307 2 14.9046Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14 11.4053L12 9.40527M12 9.40527L10 11.4053M12 9.40527V15.4053"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default OtaIcon;
